import "./sass/main.scss";
import "./js/slider";
import "./js/menu";
import "./js/moblie-modal";

